import { mdiClose } from "@mdi/js";
import { Modal, ModalProps } from "antd";
import clsx from "clsx";
import { MaterialIcon } from "components/MaterialIcon";
import React from "react";
import styles from "./ItemChooserModal.module.scss";

interface ItemChooserModalProps extends ModalProps {
  longModal?: boolean;
  titleContent?: React.ReactNode;
  modalContent?: React.ReactNode;
}

const ItemChooserModal: React.FC<ItemChooserModalProps> = ({
  onCancel,
  title,
  longModal,
  titleContent,
  children,
  className,
  ...rest
}) => {
  return (
    <Modal
      footer={null}
      width={900}
      {...rest}
      onCancel={onCancel}
      closeIcon={<MaterialIcon path={mdiClose} />}
      className={clsx(styles.modal, className, {
        [styles.longModal]: longModal,
      })}
      title={titleContent}
    >
      {children}
    </Modal>
  );
};

export default ItemChooserModal;
